import { useReport } from './hooks/use-context';

export function Deviations() {
  const { body } = useReport();
  const item = Array.isArray(body) ? body[0] : (body as any);

  const desviosSection = item?.sections?.find((s: any) =>
    s.section_name?.toLowerCase()?.includes('desvio')
  );

  const cellStyle = {
    padding: '4px 8px',
    border: '1px solid black',
  };

  const valueStyle = {
    backgroundColor: '#f2f2f2',
    fontSize: '11px',
  };

  const riskQuestions = desviosSection?.questions?.filter((q: any) =>
    q.name?.toLowerCase()?.includes('situações de risco') || 
    q.name?.toLowerCase()?.includes('situaçoes de risco')
  ) || [];

  const getAnswerText = (q: any) => {
    return q?.answers?.[0]?.option || q?.answers?.[0]?.content || '-';
  };

  const formatParentQuestionName = (name: string, index: number) => {
    const cleanName = name?.replace(/^\d+\.\s*/, '') || name;
    return `${index + 1}. ${cleanName}`;
  };

  const formatChildQuestionName = (name: string) => {
    const cleanName = name?.replace(/^\d+\.\s*/, '') || name;
    return (
      <>
        <span style={{ fontWeight: 'normal' }}>↳ </span>
        <span style={{ fontWeight: 'bold' }}>{cleanName}</span>
      </>
    );
  };

  return (
    <div style={{ marginBottom: '8px', fontFamily: 'Arial, sans-serif' }}>
      <div
        style={{
          width: '100%',
          backgroundColor: '#e5e5e5',
          textAlign: 'center',
          padding: '4px',
          fontWeight: 'bold',
          border: '1px solid black',
          borderBottom: 'none',
        }}
      >
        DESVIOS E PROVIDÊNCIAS
      </div>

      {/* Processa as filhas uma única vez para não perder performance */}
      {(() => {
        const devSection = item?.sections?.find((s: any) => s.section_name?.toLowerCase()?.includes('desvio'));
        const allQuestions = devSection?.questions || [];
        
        let currentGroup = '1';
        const childrenMap: Record<string, any[]> = {};
        
        allQuestions.forEach((q: any) => {
          if (q.name?.toLowerCase().includes('situações de risco')) return;
          
          const desvioMatch = q.name?.match(/Desvio (\d+)/i);
          if (desvioMatch) {
            currentGroup = desvioMatch[1];
          }
          if (!childrenMap[currentGroup]) childrenMap[currentGroup] = [];
          childrenMap[currentGroup].push(q);
        });

        return riskQuestions.map((riskQuestion: any, index: number) => {
          const getAnswerText = (q: any) => {
            return q?.answers?.[0]?.option || q?.answers?.[0]?.content || '-';
          };
          const rawAnswer = getAnswerText(riskQuestion);
          const rawAnswerLower = rawAnswer.toLowerCase();
          
          const prefixMatch = riskQuestion.name?.match(/^(\d+)\./);
          const rootNumber = prefixMatch ? prefixMatch[1] : null;
          const flatChildren = rootNumber ? (childrenMap[rootNumber] || []) : [];
          
          const childQuestions = riskQuestion.child_questions?.length 
            ? riskQuestion.child_questions 
            : riskQuestion.answers?.[0]?.child_questions?.length 
              ? riskQuestion.answers?.[0]?.child_questions 
              : flatChildren;
          
          const hasDeviation = childQuestions.length > 0 || 
            rawAnswerLower.includes('sim') || 
            rawAnswerLower.includes('não conforme') || 
            rawAnswerLower.includes('nao conforme') || 
            rawAnswerLower.includes('inconforme');
            
          const isConform = !hasDeviation && (rawAnswerLower.includes('não') || rawAnswerLower.includes('nao') || rawAnswerLower.includes('conforme'));

          return (
            <div key={riskQuestion.question_id || index} style={{ marginBottom: '16px', pageBreakInside: 'avoid' }}>
            <div style={{ ...cellStyle, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ fontWeight: 'bold' }}>
                {formatParentQuestionName(riskQuestion.name, index)}
              </div>
              <div style={{ display: 'flex', gap: '16px', alignItems: 'center', fontSize: '11px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <div style={{ width: '12px', height: '12px', border: '1px solid black', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', backgroundColor: '#fff' }}>
                    {isConform ? 'x' : ''}
                  </div>
                  <span>Conforme</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <div style={{ width: '12px', height: '12px', border: '1px solid black', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', backgroundColor: '#fff' }}>
                    {hasDeviation ? 'x' : ''}
                  </div>
                  <span>Não Conforme</span>
                </div>
              </div>
            </div>

            {hasDeviation && childQuestions.map((child: any, childIndex: number) => {
              const isGallery = child.type === 'gallery' || child.type === 'picture';
              return (
                <div key={child.question_id || childIndex} style={{ ...cellStyle, borderTop: 'none', paddingLeft: '48px' }}>
                  <div style={{ marginBottom: '4px' }}>
                    {formatChildQuestionName(child.name)}
                  </div>
                  {isGallery ? (
                    <div
                      style={{
                        display: 'flex',
                        gap: '8px',
                        flexWrap: 'wrap',
                        justifyContent: 'center',
                      }}
                    >
                      {child.answers?.length ? (
                        child.answers.map((ans: any, i: number) => {
                          const url = ans.content || '';
                          if (!url) return null;
                          return (
                            /* eslint-disable-next-line @next/next/no-img-element */
                            <img
                              key={`foto-${i}`}
                              src={url}
                              alt="Foto"
                              style={{
                                maxWidth: '200px',
                                maxHeight: '200px',
                                objectFit: 'contain',
                                border: '1px solid #ccc',
                              }}
                            />
                          );
                        })
                      ) : (
                        <div style={{ padding: '8px', fontStyle: 'italic', color: '#666' }}>
                          Nenhuma foto anexada.
                        </div>
                      )}
                    </div>
                  ) : (
                    <div
                      style={{
                        ...valueStyle,
                        padding: '4px',
                        minHeight: '20px',
                        border: '1px solid #ccc',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      {getAnswerText(child)}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        );
      });
      })()}
    </div>
  );
}
